import { render } from "./alert-box.vue?vue&type=template&id=39d2de76&scoped=true&ts=true"
import script from "./alert-box.vue?vue&type=script&lang=ts"
export * from "./alert-box.vue?vue&type=script&lang=ts"

import "./alert-box.vue?vue&type=style&index=0&id=39d2de76&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d2de76"]])

export default __exports__